
import { mapState } from 'vuex'
import captcha from '@/utils/captcha.js'
import { deliveryType, deliveryTypeText, parseVocCode, parseCommunicateRemark } from './utils.js'
import verificationIcon from '~/assets/img/verification-successful.png'

export default {
  props: {
    waybillNo: {
      type: String,
    },
    communicateType: {
      type: String,
      default: '',
    },
    destCountryCode: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      site: (state) => state.site,
    }),
    deliveryTypeOptions() {
      // 日本：vocCode 7,8,9；韩国：vocCode 10,11,12,13,14
      const jpCodes = ['7', '8', '9']
      const krCodes = ['10', '11', '12', '13', '14']
      const allowedCodes = this.isKRRoute ? krCodes : jpCodes
      return Object.entries(deliveryType)
        .filter(([value]) => allowedCodes.includes(value))
        .map(([value, i18nKey]) => ({
          value,
          label: this.$t(i18nKey),
        }))
    },
    isShowGatePassword() {
      return ['10', '13'].includes(this.form.vocCode)
    },
    isShowOtherRemark() {
      return this.form.vocCode === '14'
    },
    isKRRoute() {
      return this.destCountryCode === 'KR'
    },
  },
  watch: {
    'form.vocCode'(newVal) {
      if (!['10', '13'].includes(newVal)) {
        this.form.gatePassword = ''
      }
      if (newVal !== '14') {
        this.form.remark = ''
      }
    },
    dialogVisible(newVal) {
      if (newVal && this.communicateType) {
        this.form.vocCode = parseVocCode(this.communicateType)
        const { gatePassword, remark } = parseCommunicateRemark(this.communicateType)
        this.form.gatePassword = gatePassword
        this.form.remark = remark
      }
    },
  },
  data() {
    // 异步校验函数返回 Promise
    let asyncValidator = async (rule, val, callback) => {
      if (!val) {
        this.isDeliveryType = false
        callback(
          new Error(
            this.$t(
              'serviceSupport.clearanceService.certificateQuery.mobilePlaceholder'
            )
          )
        )
      } else {
        if (!this.isMobileBtn) return callback()
        this.isMobileBtn = false
        const params = {
          waybillNo: this.waybillNo,
          businessCode: '7'
        }
        this.isMobileBtnLoading = true
        // 判断是否需要滑块
        const showSlider =
          (await this.$API.support.getShowSlider(params)) || false
        if (showSlider) {
          this.isMobileBtnLoading = false
          // 唤起滑块
          try {
            await captcha.verify()
            const res = await this.checkPhone() // 改为同步返回结果的版本
            console.log('--------------', res)
            if (!res) {
              this.isDeliveryType = false
              callback(
                new Error(
                  this.$t(
                    'serviceSupport.querySupport.waybills.mobilePlaceholderError'
                  )
                )
              )
            } else {
              this.isDeliveryType = true
              callback()
            }
          } catch (error) {
            console.error('验证失败:', error)
            callback(error)
          }
        } else {
          const res = await this.checkPhone() // 改为同步返回结果的版本
            console.log('--------------', res)
            if (!res) {
              this.isDeliveryType = false
              callback(
                new Error(
                  this.$t(
                    'serviceSupport.querySupport.waybills.mobilePlaceholderError'
                  )
                )
              )
            } else {
              this.isDeliveryType = true
              callback()
            }
        }
      }
    }
    return {
      verificationIcon,
      isDeliveryType: false,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
        // 自动换行
        whiteSpace: 'normal',
      },
      dialogVisible: false,
      layout: 'vertical',
      rules: {
        phoneNumber: [
          {
            required: true,
            message: this.$t(
              'serviceSupport.clearanceService.certificateQuery.mobilePlaceholder'
            ),
            trigger: 'blur',
          },
          {
            validator: asyncValidator,
            trigger: 'blur',
          },
        ],
        vocCode: [
          {
            required: true,
          },
        ],
        gatePassword: [
          {
            pattern: /^\d{0,20}$/,
            message: this.$t('serviceSupport.querySupport.waybills.gatePasswordValidationError'),
            trigger: 'blur',
          },
        ],
        remark: [
          {
            max: 50,
            message: this.$t('serviceSupport.querySupport.waybills.otherRemarkValidationError'),
            trigger: 'blur',
          },
          {
            validator: (rule, val, callback) => {
              if (val && val.includes('#')) {
                callback(new Error(this.$t('serviceSupport.querySupport.waybills.otherRemarkValidationError')))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      },
      isBtnDisabled: true,
      isMobileBtnLoading: false,
      isNextLoading: false,
      form: {
        phoneNumber: '',
        vocCode: '',
        gatePassword: '',
        remark: '',
      },
      isMobileBtn: false,
    }
  },
  created() {
    if (process.client) {
      captcha.init({ lang: this.locale, app: this })
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 校验手机号
    handleFetchCode() {
      this.isMobileBtn = true
      this.$refs.verifyFormRef.validateField(['phoneNumber'])
    },
    // 验证手机号
    async checkPhone() {
      const params = {
        phoneNo: this.form.phoneNumber, // 手机号
        waybillNo: this.waybillNo, // 运单号
        businessCode: '7',
      }
      try {
        this.isMobileBtnLoading = true
        const res = await this.$API.support.checkPhoneNumberApi(params)
        if (res) {
          this.isMobileBtnLoading = false
          this.isBtnDisabled = false
        } else {
          this.isMobileBtnLoading = false
          this.isBtnDisabled = true
        }
        return !!res
      } catch (e) {
        this.isMobileBtnLoading = false
        console.error(e)
        return false
      }
    },
    handlePhoneChange() {
      this.isMobileBtnLoading = false
      this.isBtnDisabled = true
      this.isDeliveryType = false
    },
    // 提交
    verifySubmit() {
      // 校验是否选择了派件方式
      if (this.isDeliveryType && !this.form.vocCode) {
        this.$message.warning(this.$t('serviceSupport.querySupport.waybills.deliveryPreferencePlaceholder'))
        return
      }
      this.isNextLoading = true
      this.$refs.verifyFormRef.validate((valid) => {
        this.isNextLoading = false
        if (valid) {
          // 韩国运单已选过不允许二次修改
          const existingVocCode = parseVocCode(this.communicateType)
          if (this.destCountryCode === 'KR' && existingVocCode) {
            this.$message.warning(this.$t('serviceSupport.querySupport.waybills.deliveryPreferenceNoEdit'))
            this.isDeliveryType = false
            this.dialogVisible = false
            this.showDialogVisible()
            return
          }
          // 判断是否修改了vocCode
          if (existingVocCode && this.form.vocCode == existingVocCode) {
            this.isDeliveryType = false
            this.dialogVisible = false
            this.$emit('success', {
              vocCode: this.form.vocCode,
            })
            this.showDialogVisible()
            return
          }
          this.onSubmit()
        }
      })
    },
    async onSubmit() {
      const vocCode = this.form.vocCode
      const textMap = deliveryTypeText[vocCode]
      if (!textMap) {
        return
      }
      // 拼接 remark
      let remark = ''
      if (this.form.gatePassword) {
        remark += `Gate password：${this.form.gatePassword}`
      }
      if (this.form.remark) {
        if (remark) remark += ' '
        remark += this.form.remark
      }
      const params = {
        vocCode: this.form.vocCode,
        waybillNo: this.waybillNo,
        businessType: '7',
        vocEn: textMap.en,
        vocCn: textMap.zh,
        phoneNo: this.form.phoneNumber,
        remark,
      }
      try {
        const res = await this.$API.support.updateVocExecuteApi(params)
        if (res) {
          this.isDeliveryType = false
          this.dialogVisible = false
          this.$emit('success', {
            vocCode: this.form.vocCode,
          })
          this.showDialogVisible()
        }else {
          // 显示异常
          this.$message.error(this.$t('serviceSupport.querySupport.waybills.prompt11'))
        }
      } catch (e) {
        console.error(e)
      }
    },
    showDialogVisible() {
      this.form = JSON.parse(
        JSON.stringify({
          phoneNumber: '',
          vocCode: '',
          gatePassword: '',
          remark: '',
        })
      )
    },
  },
}
